import { useIntl } from 'react-intl'

import { UserSummaryFragment } from 'shared/types/gradoo/graphql'
import Avatar from 'shared/ui/Avatar'
import Checkbox from 'shared/ui/Checkbox'
import IconButton, { IconButtonIntents } from 'shared/ui/IconButton'
import ProgressLine from 'shared/ui/ProgressLine'

import { Center, Container, Counts, Name } from './Style'

type ProfileItemProps = {
  userSummary: UserSummaryFragment
  totalQuestions: number
  totalImages: number
  onButtonClick: () => void
  isMarked?: boolean
  onToggleMark?: () => void
}

const ProfileItem: React.FC<ProfileItemProps> = ({
  userSummary,
  totalQuestions,
  totalImages,
  onButtonClick,
  isMarked,
  onToggleMark
}) => {
  const { formatMessage } = useIntl()

  if (!userSummary) {
    return null
  }

  const currentProgress =
    (userSummary.questionsAnswered || 0) +
    (userSummary.imagesUploaded || 0)
  const totalProgress = totalQuestions + totalImages

  const percentage = (currentProgress / totalProgress) * 100

  return (
    <Container withBorder onClick={onButtonClick} $marked={isMarked}>
      <div
        onClick={e => {
          e.stopPropagation()
        }}
      >
        <Checkbox
          checked={!!isMarked}
          onChange={() => onToggleMark?.()}
        />
      </div>
      <Avatar
        src={
          userSummary.userGroup?.avatar ||
          userSummary.userGroup?.defaultAvatar?.avatar ||
          ''
        }
      />
      <Center>
        <Name>
          {`${userSummary.userGroup?.user?.firstName} ${userSummary.userGroup?.user?.lastName}`}
        </Name>
        <ProgressLine percentage={percentage} />
        <Counts>
          {formatMessage(
            { id: 'Panel.profilePage.item.answersCount' },
            {
              count: userSummary.questionsAnswered,
              from: totalQuestions
            }
          )}
          {' | '}
          {formatMessage(
            { id: 'Panel.profilePage.item.imagesCount' },
            { count: userSummary.imagesUploaded, from: totalImages }
          )}
        </Counts>
      </Center>

      <IconButton
        data-testid={`ProfileItemIconButton:${userSummary.userGroup.id}`}
        onClick={onButtonClick}
        icon="arrow-right-filled"
        size={14}
        intent={IconButtonIntents.secondary}
      />
    </Container>
  )
}

export default ProfileItem
export { default as ProfilePageItemSkeleton } from './Skeleton'
